import * as React from 'react';
import { Layer, Source } from 'react-map-gl/mapbox';

import { IReference } from '../types/IReference';

interface IProps {
  reference: IReference;
}

const ReferenceLayer = (props: IProps) => {
  const reference = props.reference;
  const geojson = reference.geojson;
  const property = reference.property;

  // Determine min and max value of selected property.
  const minVal = React.useMemo(() => {
    if(!property || !geojson) return 0;
    return Math.min(...geojson.features.map(f => Number(f.properties?.[property])));
  }, [property, geojson]);

  const maxVal = React.useMemo(() => {
    if(!property || !geojson) return 0;
    return Math.max(...geojson.features.map(f => Number(f.properties?.[property])));
  }, [property, geojson]);

  const fillColor = props.reference.gradient.map(stop => {
    const range = maxVal - minVal;
    // Note: Mapbox can't handle colors of shape "#rrggbbaa", only "#rrggbb".
    return [ stop.pos * range + minVal, stop.color.substring(0, 7) ];
  }).flat();

  if (!geojson) return null;

  return (
    <Source type="geojson" data={geojson}>
      <Layer
        type="fill"
        paint={{
          "fill-color": property ? [
            'interpolate',
            ['linear'],
            ['get', property],
            ...fillColor
          ] : '#000000',
          "fill-opacity": reference.opacity / 100,
        }}
      />
      <Layer
        type="line"
        paint={{
          "line-color": "#ffffff",
          "line-opacity": reference.opacity / 100,
          "line-width": 1,
        }}
      />
    </Source>
  )
}

export { ReferenceLayer }
